<template>
  <div class="invoicelist-receipt">
    <div class="datatable-form__header atr-header-wrap mb-4">
      <div class="invoiceList-search_item">
        <label>Receipt Date</label>
        <el-date-picker
          v-model="inputFromDate"
          type="daterange"
          range-separator="To"
          start-placeholder="From"
          end-placeholder="End"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
        >
        </el-date-picker>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="studName" type="text" placeholder="Student Name"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="studNO" type="text" placeholder="Student NO"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <el-input v-model="recName" type="text" placeholder="Receipt NO"></el-input>
      </div>
      <div class="invoiceList-search_item">
        <!--                <el-input v-model="recStatus" type="text" placeholder="Receipt Status"></el-input>-->
        <el-select style="max-width: 150px" v-model="recStatus" clearable placeholder="Receipt Status">
          <el-option v-for="item in recOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
      <div class="invoiceList-search_item form-group flex-1">
        <el-select style="max-width: 150px" v-model="schSelected" clearable placeholder="Select School">
          <el-option v-for="item in userSchools" :key="item.CONSchool" :label="item.SCH_Name" :value="item.CONSchool"> </el-option>
        </el-select>
      </div>
      <div class="datatable-form__submit text-center">
        <button class="btn btn-success searchbtn" id="btnReceiptSearch" v-on:click="Search('receipt')">Search</button>
      </div>
    </div>
    <div class="">
      <div class="datatable-form__submit text-right"></div>
      <div class="pb-5">
        <el-tabs v-model="receiptTab" type="card">
          <el-tab-pane label="Receipt List" name="first">
            <div class="empty-list_image" v-if="ReceiptListInt && ReceiptListInt.length < 1">
              <strong>{{ startupText }}</strong>
              <img src="../../assets/notfound.png" />
            </div>
            <div v-if="ReceiptListInt && ReceiptListInt.length > 0" class="datatable_group">
              <div>
                <el-button-group class="pull-right mb-3">
                  <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadAsZip()">Download</el-button>
                  <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="showBModal()">Send Email</el-button>
                  <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="showTestBModal()"
                    >Send Batch Email (test)</el-button
                  >
                </el-button-group>
              </div>
              <data-tables
                :data="ReceiptListInt"
                :action-col="ReceiptListAction"
                @selection-change="changeSelection"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="ReceiptListTable"
              >
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column v-for="item in ReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Receipt List Without Email" name="second">
            <div class="empty-list_image" v-if="ReceiptListWithoutPayeeEmailInt && ReceiptListWithoutPayeeEmailInt.length < 1">
              <strong>{{ startupText }}</strong>
              <img src="../../assets/notfound.png" />
            </div>
            <div v-if="ReceiptListWithoutPayeeEmailInt && ReceiptListWithoutPayeeEmailInt.length > 0" class="datatable_group">
              <h5 class="text-left mb-3">Receipt List Without Email(Please take note)</h5>
              <div>
                <el-button-group class="pull-right mb-3">
                  <el-button size="small" type="primary" icon="el-icon-download" :disabled="AuditDisabled" v-on:click="downloadReceiptWithoutEmailAsZip()"
                    >Download</el-button
                  >
                </el-button-group>
              </div>
              <data-tables :data="ReceiptListWithoutPayeeEmailInt" width="55" stripe tooltip-effect="light" border ref="InvoiceListWithoutPayerEmailTable">
                <el-table-column v-for="item in ReceiptListWithoutPayeeEmail" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <b-modal id="showBatchEmailConfirmationModal" hide-footer title="Send Email Confirmation" size="sm" ref="showBatchEmailConfirmationModal">
      <data-tables
        :data="SelectedReceiptListInts"
        v-if="SelectedReceiptListInts && SelectedReceiptListInts.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in selectedReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnSendEmail()" :disabled="propSendDisabled">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnSendEmail('No')" :disabled="propSendDisabled">No</el-button>
      </div>
    </b-modal>
    <b-modal
      id="showBatchEmailConfirmationModalWithBreakdown"
      hide-footer
      title="Send Email Confirmation With Breakdown"
      size="sm"
      ref="showBatchEmailConfirmationModalWithBreakdown"
    >
      <data-tables
        :data="SelectedReceiptListInts"
        v-if="SelectedReceiptListInts && SelectedReceiptListInts.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in selectedReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnSendEmailWithBreakdown()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnSendEmailWithBreakdown('No')">No</el-button>
      </div>
    </b-modal>
    <!--        //testing only: start-->
    <b-modal id="showTestingBModal" hide-footer title="Send Email Confirmation(TEST ONLY!)" size="sm" ref="showTestingBModal">
      <data-tables
        :data="testingSelectedReceiptListInt"
        v-if="testingSelectedReceiptListInt && testingSelectedReceiptListInt.length > 0"
        width="55"
        stripe
        tooltip-effect="light"
        border
        ref="selectedListTable"
      >
        <el-table-column v-for="item in testingSelectedReceiptList" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom"> </el-table-column>
        <el-table-column label="Email(TEST)" min-width="100px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.newTestEmail" type="text" placeholder="Email(Key in test email)"></el-input>
          </template>
        </el-table-column>
      </data-tables>

      <div class="invoice-modal_submitBox">
        <strong>Proceed to send email??</strong>
        <el-button size="small" type="primary" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail()">Yes</el-button>
        <el-button size="small" type="danger" icon="el-icon-s-promotion" v-on:click="btnTestingSendEmail('No')">No</el-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import DataSource from '../../data/datasource'
import moment from 'moment'
import Cookies from 'js-cookie'

export default {
  name: 'InvoiceList-Receipt',
  data() {
    return {
      startupText: '',
      inputFromDate: [],
      inputFromDueDate: [],
      studName: '',
      studNO: '',
      recName: '',
      recStatus: 'Active',
      recOptions: [
        {
          value: 'Active',
          label: 'Active',
        },
        {
          value: 'Void',
          label: 'Void',
        },
      ],
      schSelected: '',
      userSchools: [],
      receiptTab: 'first',

      currentSchoolID: '',

      //receiptList:start
      ReceiptListInt: [],
      ReceiptList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'IH_Invoice_No',
          label: 'Invoice NO',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Status',
        },
        {
          prop: 'receiptDate',
          label: 'ReceiptDate',
        },
        {
          prop: 'Amount',
          label: 'Amount',
        },
        {
          prop: 'GstAmount',
          label: 'Gst',
        },
        {
          prop: 'TotalAmountIncGst',
          label: 'TotalIncGst',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'email',
          label: 'Payee Email',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      ReceiptListAction: {
        label: 'Info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + row.FK_RH_Student_ID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More',
          },
        ],
      },

      ReceiptListWithoutPayeeEmailInt: [],
      ReceiptListWithoutPayeeEmail: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
      ],
      ReceiptListWithoutPayeeEmailAction: {
        label: 'More info',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-info',
            },

            handler: row => {
              this.studentCourseID = row.PK_Student_Course_ID
              this.studentID = row.FK_Student_ID
              this.courseStatus = row.SCRS_Status
              if (this.studentCourseID) {
                this.$router.push('StudentPaymentPlan?sid=' + this.studentID + '&scid=' + this.studentCourseID + '&crsStatus=' + this.courseStatus)
              } else {
                this.$notify.error({
                  title: 'Message',
                  message: 'Error.',
                })
              }
            },
            label: 'More info',
          },
        ],
      },
      //receiptList:end

      tempResp: [],
      spdSelection: [],
      zipType: '',
      testingSelectedReceiptListInt: [],
      testingSelectedReceiptList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      SelectedReceiptListInts: [],
      selectedReceiptList: [
        {
          prop: 'studentName',
          label: 'Student Name',
        },
        {
          prop: 'RH_Receipt_Status',
          label: 'Receipt Status',
        },
        {
          prop: 'RH_Receipt_Name',
          label: 'Receipt Name',
        },
        {
          prop: 'email',
          label: 'Email',
        },
        {
          prop: 'sponsor_type',
          label: 'Payee',
        },
        {
          prop: 'fatherEmail',
          label: 'Father Email',
        },
        {
          prop: 'motherEmail',
          label: 'Mother Email',
        },
      ],
      AuditDisabled: false,
    }
  },
  mounted() {
    this.initEvent()
    //todo: for external auditor only
    let conType = Cookies.get('userTypeSession')
    if (conType === 'Auditor') {
      this.AuditDisabled = true
    }
    //todo: for external auditor only
  },
  props: ['propReceiptListInt', 'propCurrentSchoolID', 'propReceiptListWithoutPayeeEmailInt', 'propZipType', 'propSpdSelection', 'propSendDisabled'],
  methods: {
    async changeSelection(val) {
      this.spdSelection = val
    },
    initEvent() {
      this.ReceiptListInt = this.propReceiptListInt
      this.currentSchoolID = this.propCurrentSchoolID
      this.ReceiptListWithoutPayeeEmailInt = this.propReceiptListWithoutPayeeEmailInt
      this.zipType = this.propZipType
      this.spdSelection = this.propSpdSelection
      this.getUserSch()
      //  console.log(this.zipType)
    },
    async getUserSch() {
      try {
        const resp = await DataSource.shared.getUserSch()
        this.userSchools = resp.Table
      } catch (e) {
        this.results = e
      }
    },
    async Search(type) {
      try {
        this.clearTablesList()
        this.clearBModalList()
        //todo: to check empty input, force to input at least 1 datetime
        if (
          this.inputFromDate &&
          this.inputFromDate.length < 1 &&
          this.inputFromDueDate &&
          this.inputFromDueDate.length < 1 &&
          !this.studName &&
          !this.studNO &&
          !this.recName
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Please input at least 1 item!',
          })
        } else {
          this.$vs.loading()
          const resp = await DataSource.shared.getReceiptList(
            this.invName,
            this.recName,
            this.inputFromDate[0],
            this.inputFromDate[1],
            this.studNO,
            this.studName,
            this.recStatus,
            '',
            this.schSelected,
          )
          if (resp) {
            if (resp.code === '88') {
              window.location.replace('/')
            } else if (resp.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Search Student: Error',
              })
            } else if (resp.code === '2') {
              this.$notify.error({
                title: 'No Record',
                message: 'No Student Found',
              })
            } else {
              this.tempResp = resp.Table
              // this.ReceiptListInt = this.tempResp;
              this.tempResp.forEach(m => {
                if (m.email) {
                  this.ReceiptListInt.push(m)
                } else {
                  this.ReceiptListWithoutPayeeEmailInt.push(m)
                  // console.log('this.ReceiptListWithoutPayeeEmailInt=',this.ReceiptListWithoutPayeeEmailInt);
                }
              })
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async clearTablesList() {
      this.ReceiptListInt = []
      this.ReceiptListWithoutPayeeEmailInt = []
    },
    async clearBModalList() {
      //   console.log("clearBModalList");
      this.spdSelection = []
      this.SelectedReceiptListInts = []
    },
    async downloadAsZip() {
      try {
        let spdList = []
        let selectedObjList = []
        spdList = this.spdSelection
        if (this.spdSelection && this.spdSelection.length < 1) {
          alert('Please select at least 1 item!')
        } else {
          this.$vs.loading()
          spdList.forEach(m => {
            let List = {
              RH_Receipt_No: m.RH_Receipt_No,
            }
            selectedObjList.push(List)
          })

          const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
          if (resp.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Cannot download files!',
            })
          } else {
            var byteChar = atob(resp.code)
            var byteNo = new Array(byteChar.length)
            for (var i = 0; i < byteChar.length; i++) {
              byteNo[i] = byteChar.charCodeAt(i)
            }
            var byteArray = new Uint8Array(byteNo)
            var file = new Blob([byteArray], { type: 'application/zip;base64' })
            var fileUrl = URL.createObjectURL(file)
            window.location.href = fileUrl
          }
          this.$vs.loading.close()
        }
      } catch (e) {
        this.results = e
      }
    },
    async downloadReceiptWithoutEmailAsZip() {
      try {
        let selectedObjList = []
        this.ReceiptListWithoutPayeeEmailInt.forEach(m => {
          let List = {
            IH_Invoice_No: m.IH_Invoice_No,
          }
          selectedObjList.push(List)
        })
        const resp = await DataSource.shared.getZipFiles(JSON.stringify(selectedObjList), this.zipType)
        if (resp.code === '99') {
          this.$notify.error({
            title: 'Error',
            message: 'Cannot download files!',
          })
        } else {
          let byteChar = atob(resp.code)
          let byteNo = new Array(byteChar.length)
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i)
          }
          let byteArray = new Uint8Array(byteNo)
          let file = new Blob([byteArray], { type: 'application/zip;base64' })
          let fileUrl = URL.createObjectURL(file)
          window.location.href = fileUrl
        }
      } catch (e) {
        this.results = e
      }
    },
    async showBModal() {
      try {
        //todo: check if no checkbox selected
        //   console.log(this.spdSelection);
        if (this.spdSelection && this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          await this.getSelectedList()
          this.$refs.showBatchEmailConfirmationModal.show()
        }
      } catch (e) {
        this.results = e
      }
    },
    async showBModalWithBreakdown() {
      try {
        if (this.spdSelection && this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showBatchEmailConfirmationModalWithBreakdown.show()
          await this.getSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    async getSelectedList() {
      this.SelectedReceiptListInts = this.spdSelection
    },
    async getTestingSelectedList() {
      this.testingSelectedReceiptListInt = this.spdSelection
    },
    //Testing items only: start
    async showTestBModal() {
      try {
        //todo: check if no checkbox selected
        if (this.spdSelection && this.spdSelection.length < 1) {
          this.$notify.error({
            title: 'Error',
            message: 'Please select at least 1 item!',
          })
        } else {
          this.$refs.showTestingBModal.show()
          await this.getTestingSelectedList()
        }
      } catch (e) {
        this.results = e
      }
    },
    hideModal() {
      this.$refs.showBatchEmailConfirmationModal.hide()
      this.$refs.showTestingBModal.hide()
      this.$refs.showBatchEmailConfirmationModalWithBreakdown.hide()
    },
    async btnSendEmail(value) {
      this.$emit('btnSendEmail', value, this.spdSelection, 'receipt')
    },
    async btnSendEmailWithBreakdown(value) {
      this.$emit('btnSendEmailWithBreakdown', value, this.spdSelection, 'receipt')
    },
    async btnTestingSendEmail(value) {
      this.$emit('btnTestingSendEmail', value, this.spdSelection, 'receipt')
    },
    async btnTestingSendEmailWithBreakdown(value) {
      this.$emit('btnTestingSendEmailWithBreakdown', value, this.spdSelection, 'receipt')
    },
  },
}
</script>
<style scoped></style>
<style>
#invoice-list .invoicelist-receipt .action-list button {
  padding: 5px !important;
  margin: 0;
}

#invoice-list .invoicelist-receipt .action-list {
  margin: 0 -10px !important;
}
</style>
